import * as React from 'react';
import { ITemplate } from 'entities/template/template';
import { IValue as ImportedValue, TemplatesListProvider } from './TemplatesListProvider';
import { ActionTypes, TemplatesListReducer } from './TemplatesListReducer';
export type IValue = ImportedValue;

export const filterByOptions = {
  showAllTemplates: 'showAllTemplates',
  displayTypeEmbedded: 'displayTypeEmbedded',
  displayTypePopup: 'displayTypePopup',
};

export const sortByOptions = {
  nameAToZ: 'nameAToZ',
  mostRecent: 'mostRecent',
  oldestToMostRecent: 'oldestToMostRecent',
};

export interface IAction {
  type: ActionTypes;
  payload?: any;
}

export type Dispatch = (action: IAction) => void;

export interface IState {
  selectedTemplate?: ITemplate;
  supportedLanguages: string[];
  filterBy: keyof typeof filterByOptions;
  sortingFilter: keyof typeof sortByOptions;
}

export const defaultContextValues: IState = {
  selectedTemplate: null,
  supportedLanguages: [],
  filterBy: 'showAllTemplates',
  sortingFilter: 'nameAToZ',
};

export const TemplateListStateContext = React.createContext<IState | undefined>(undefined);
export const TemplateListDispatchContext = React.createContext<Dispatch | undefined>(undefined);

function useTemplatesListState() {
  const context = React.useContext(TemplateListStateContext);
  if (context === undefined) {
    throw new Error('useTemplatesListState must be used within a TemplatesListProvider');
  }
  return context;
}

function useTemplatesListDispatch() {
  const context = React.useContext(TemplateListDispatchContext);
  if (context === undefined) {
    throw new Error('useTemplatesListDispatch must be used within a TemplatesListProvider');
  }
  return context;
}
export { TemplatesListProvider, TemplatesListReducer, useTemplatesListState, useTemplatesListDispatch };
